var render = function render(){var _vm=this,_c=_vm._self._c;return _c('live-map',{attrs:{"tags":_vm.Tags}})
}
var staticRenderFns = []

export { render, staticRenderFns }